<div class="d-flex flex-column gap-4">
    <div class="page-title d-flex justify-content-between align-items-center">
        <div class="asset-driver-title">
            <button class="btn link-btn btn-back">
                <i class="app-icon icon icon-chevron-left icon-xxl" (click)="backHandler()"></i>
            </button>
            <span HJSuppress>{{asset?.assetName}}</span>
        </div>

        <div class="d-flex justify-content-end gap-3">
            <button 
                class="btn outline-btn red-btn" 
                (click)="redirectReportIncident(asset.contractExternalEntityId, asset.assetId)">
                {{'assetDriver.reportIncident' | translate}} 
            </button>
            <button 
                class="btn outline-btn"    
                (click)="redirectAssetJourney(asset.assetId)">
                {{'assetDriver.seeAssetJourney' | translate}} 
            </button>
            <div class="buttons-divider-line"></div>
            <button 
                class="btn btn-primary text-light" 
                (click)="redirectDocumentRequest(asset.contractExternalEntityId, asset.assetId)">
                {{'assetDriver.documentRequest' | translate}} 
            </button>
        </div>
    </div>


    <div *ngIf="dataLoaded">
        <div class="card">
            <div class="card-body card-body-asset-driver-details">
                <div class="grid-container" [ngClass]="{'grid-container4': isFleetManagement}">
                    <div class="value-col" *ngIf="isFleetManagement && asset.driverName">
                        <div class="l-header">
                            {{'assetDriver.driverName' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.driverName }}
                            <div class="badge custom-badge ms-1" *ngIf="asset?.driverName "
                                [ngClass]="[asset.driverClass === 'A'?'success':'info']">{{asset.driverClass}}
                            </div>
                        </div>
                    </div>
                    <div class="value-col">
                        <div class="l-header">
                            {{'assetDriver.serialNumber' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.vin }}
                        </div>
                    </div>
                    <div class="value-col">
                        <div class="l-header">
                            {{'assetDriver.plateNumber' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.registrationNumber }}
                        </div>
                    </div>
                    <div class="value-col" *ngIf="isFleetManagement">
                        <div class="l-header">
                            {{'assetDriver.category' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.dictionaryAssetType.value }}
                        </div>
                    </div>
                    <div class="value-col" *ngIf="!isFleetManagement">
                        <div class="l-header">
                            {{'assetDriver.mileage' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset.mileage | number: '1.0' }} km <span *ngIf="lastInspectionDate">{{ 'assetDriver.lastInspection' | translate : { date: lastInspectionDate | localizedDate} }}</span>
                        </div>
                    </div>
                    <div class="value-col" *ngIf="isFleetManagement">
                        <div class="l-header">
                            {{'assetDriver.currentMileage' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset.mileage | number: '1.0' }} km 
                        </div>
                    </div>
                    <div class="value-col" *ngIf="isFleetManagement">
                        <div class="l-header">
                            {{'assetDriver.contract' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.contractNumber }}
                        </div>
                    </div>
                    <div class="value-col" *ngIf="isFleetManagement">
                        <div class="l-header">
                            {{'assetDriver.servicePartner' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.servicePartner }}
                        </div>
                    </div>
                    <div class="value-col" *ngIf="isFleetManagement">
                        <div class="l-header">
                            {{'assetDriver.availableService' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{ asset?.availableService }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column mt-4">
            <div class="page-category mb-3">
                {{'assetDriver.assetDocuments' | translate}}
            </div>
            <div class="grid-container gap-3" [ngClass]="{'grid-container4': !isFleetManagement}">
                <div class="card" *ngFor="let documentName of assetDocuments">
                    <div class="d-flex justify-content-between document-item py-3 px-4">
                        <div class="d-flex align-items-center">
                            <div class="document-icon">
                                <kendo-icon HJSuppres [name]="getFileTypeIcon(documentName)" class="file-icon"></kendo-icon>
                            </div>
                            <div>
                                <div HJSuppress class="fw-bold fs-6">{{ documentName }}</div>
                                <div class="d-flex gap-1">
                                    <div class="document-verification">{{'assetDriver.checkedBy' | translate}}</div> 
                                    <img src="assets/img/global-SVG-assets/smartha.svg" alt ="smartha" />
                                </div>
                            </div>
                        </div>

                        <button class="btn m-outline-btn" (click)="downloadDocument(documentName)">
                            <i class="app-icon icon icon-download icon-xl"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="divider-line  mt-4"></div>

        <div class="mt-4">
            <div class="page-category  mb-3">
                {{'assetDriver.driverDocuments' | translate}}
            </div>

            <div class="grid-container gap-3">
                <div class="card d-flex dashed action-card cursor-pointer py-3 px-4 text-primary">
                    <span>
                        {{'assetDriver.uploadPersonalDocuments' | translate}}
                    </span>
                </div>
                <div class="card" *ngFor="let documentName of driverDocuments">
                    <div class="d-flex justify-content-between document-item py-3 px-4">
                        <div class="d-flex align-items-center">
                            <div class="document-icon">
                                <kendo-icon HJSuppres [name]="getFileTypeIcon(documentName)" class="file-icon"></kendo-icon>
                            </div>
                            <div>
                                <div HJSuppress class="fw-bold fs-6">{{ documentName }}</div>
                                <div class="d-flex gap-1">
                                    <div class="document-verification">{{'assetDriver.checkedBy' | translate}}</div> 
                                    <img src="assets/img/global-SVG-assets/smartha.svg" alt ="smartha" />
                                </div>
                            </div>
                        </div>

                        <button class="btn m-outline-btn" (click)="downloadDocument(documentName)">
                            <i class="app-icon icon icon-download icon-xl"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="divider-line mt-4"></div>

        <div class="mt-4">
            <div class="page-category pb-3">
                {{'assetDriver.availableServices' | translate}}
            </div>

            <div class="mt-3 pb-3" *ngFor="let contractItemService of asset.contractItemServices">
                <div class="d-flex justify-content-between service-category mb-3">
                    <div class="d-flex align-items-center gap-3 flex-shrink-0 text-primary" >
                        <i class="app-icon icon icon-check-circle-fill icon-xxl"></i>
                        <div class="d-flex gap-2">
                            {{ contractItemService.name }}
                            <div class="next-event ms-1 px-3 py-1" 
                                [class.next-event-red]="(getDaysBetween(contractItemService.nextDueDate, utcToday) < contractItemServiceUrgentInDays) && 
                                !contractItemService.isFuelRefill">
                                <span *ngIf="!contractItemService.isFuelRefill">
                                    {{'assetDriver.nextDue' | translate}} {{ contractItemService.nextDueDate | localizedDate }}
                                </span>
                                <span *ngIf="contractItemService.isFuelRefill && contractItemService.historyServices && contractItemService.historyServices.length > 0">
                                    {{'assetDriver.lastRefuel' | translate}} {{ getMaxDateByHistoryServices(contractItemService.historyServices) | localizedDate }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="contractItemService.historyServices?.length > 2">
                        <i class="app-icon icon icon-arrow-left icon-xl me-3" role="button" 
                            [class.disabled]="contractItemService.startWith === 0"
                            (click)="previousHistoryService(contractItemService)"></i>
                        <i class="app-icon icon icon-arrow-right icon-xl me-2" role="button" 
                            [class.disabled]="contractItemService.startWith + 2 === contractItemService.historyServices.length"
                            (click)="nextHistoryService(contractItemService)"></i>
                    </div>
                </div>
                <div class="grid-container gap-4 ms-5">
                    <div *ngIf="contractItemService.isFuelRefill" class="d-flex card dashed action-card book-now-card py-3 px-4 text-primary">
                        <div class="barcode-cointainer">
                            <img src="assets/img/barcode.png" alt="Barcode" class="barcode" />
                        </div>
                    </div>
                    <div *ngIf="!contractItemService.isFuelRefill" class="card dashed action-card book-now-card cursor-pointer py-3 px-4 text-primary" (click)="bookAppointmentHandler(contractItemService.code, contractItemService.name)">
                        <span>
                            {{'assetDriver.bookNow' | translate}}
                        </span>
                    </div>
                    <div class="card" *ngFor="let historyService of contractItemService.showHistoryServices">
                        <div class="d-flex justify-content-between mx-1 px-3 py-4">
                            <div>
                                <div class="event-title mb-2 pb-1">
                                    <span *ngIf="!contractItemService.isFuelRefill">
                                        {{ contractItemService.name }} {{'assetDriver.on' | translate}}
                                    </span>
                                    <span *ngIf="contractItemService.isFuelRefill">
                                        {{'assetDriver.refillOn' | translate}}
                                    </span>
                                    {{ historyService.date | localizedDate}}
                                </div>
                                <div class="event-detail text-primary">
                                    <span class="cursor-pointer">
                                        {{'assetDriver.seeDetails' | translate}}
                                    </span>
                                </div>
                            </div>

                            <div *ngIf="contractItemService.isFuelRefill" class="d-flex flex-column align-items-center">
                                <div class="history-value">
                                    {{ historyService.refillAmount }}
                                </div>
                                <div class="history-additional-value">
                                    {{ historyService.refillKm }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
